import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { SharedModule } from "src/app/shared/shared.module";
import { FacilitiesRoutingModule } from "./facilities-routing.module";
import { FacilitiesComponent } from "./facilities.component";
import { AddFacilityComponent } from './add-facility/add-facility.component';

@NgModule({
  declarations: [
    FacilitiesComponent,
    AddFacilityComponent
  ],
  imports: [
    CommonModule,
    FacilitiesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    LoaderModule,
    SharedModule,
    //CalendarModule
  ]
})
export class FacilitiesModule { }